import React, { } from 'react'
import { Redirect } from 'react-router-dom'
function Protected(props) {
    var userid = localStorage.getItem("adminuserid");
    return <div> {userid ? <props.cmp /> : <Redirect to="adminlogin"></Redirect>} </div>
}
export default Protected;